import { defineMessages } from 'react-intl';

export const leftMouseClick = 1;

export const middleMouseClick = 4;

export const ADJUSTED_LAYOUT_OFFSET = { x: -10, y: 30 };

export const PREPOSITION = defineMessages({
  to: {
    id: 'Sovq/8OI4lXhwuJJ',
    defaultMessage: 'to',
    description: 'from / to',
  },
});
